import React from "react"

export default function Instagram() {
  return (
    <svg
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.6225 0H8.07765C3.81749 0 0.351562 3.46609 0.351562 7.72626V20.2711C0.351562 24.5314 3.81749 27.9973 8.07765 27.9973H20.6225C24.883 27.9973 28.3489 24.5313 28.3489 20.2711V7.72626C28.3491 3.46609 24.883 0 20.6225 0ZM25.865 20.2711C25.865 23.1617 23.5133 25.5133 20.6227 25.5133H8.07765C5.1872 25.5135 2.83562 23.1617 2.83562 20.2711V7.72626C2.83562 4.8358 5.1872 2.48406 8.07765 2.48406H20.6225C23.5131 2.48406 25.8649 4.8358 25.8649 7.72626V20.2711H25.865Z"
        fill="#3870DE"
      />
      <path
        d="M14.349 6.78455C10.371 6.78455 7.13477 10.0208 7.13477 13.9988C7.13477 17.9766 10.371 21.2126 14.349 21.2126C18.3269 21.2126 21.5632 17.9766 21.5632 13.9988C21.5632 10.0208 18.3269 6.78455 14.349 6.78455ZM14.349 18.7284C11.7409 18.7284 9.61883 16.6067 9.61883 13.9986C9.61883 11.3903 11.7407 9.26844 14.349 9.26844C16.9572 9.26844 19.0791 11.3903 19.0791 13.9986C19.0791 16.6067 16.9571 18.7284 14.349 18.7284Z"
        fill="#3870DE"
      />
      <path
        d="M21.8656 4.67847C21.387 4.67847 20.9168 4.87222 20.5788 5.21171C20.2392 5.54954 20.0439 6.01986 20.0439 6.50011C20.0439 6.97887 20.2394 7.44902 20.5788 7.78851C20.9167 8.12634 21.387 8.32175 21.8656 8.32175C22.3458 8.32175 22.8145 8.12634 23.154 7.78851C23.4935 7.44902 23.6872 6.97871 23.6872 6.50011C23.6872 6.01986 23.4935 5.54954 23.154 5.21171C22.8162 4.87222 22.3458 4.67847 21.8656 4.67847Z"
        fill="#3870DE"
      />
    </svg>
  )
}
